import { atom } from 'jotai';

export const upgradePlanAtom = atom({
  isModalActive: false,
});

export const upgradeSSOAtom = atom({
  isModalActive: false,
});
